// extracted by mini-css-extract-plugin
module.exports = {"line":"MenuDivider_line__9m2al","row":"MenuDivider_row__2J2vF","title":"MenuDivider_title__3cHgZ"};